<div class="confirmation-container">
    <div class="title">{{'schedule.' + title | translate}}</div>
    <div class="description">{{'schedule.' + message | translate}}</div>
</div>
